import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type AbilitiesService from 'ember-can/services/abilities';
import type FeatureFlagsService from 'garaje/services/feature-flags';
import type HrisInstallService from 'garaje/services/hris-install';

export default class LocationOverviewHrisRoute extends Route {
  @service declare abilities: AbilitiesService;
  @service declare featureFlags: FeatureFlagsService;
  @service declare hrisInstall: HrisInstallService;
  @service declare router: RouterService;

  titleToken = 'HRIS Dashboard';

  async beforeModel(): Promise<void> {
    if (!this.featureFlags.isEnabled('integration-hris-dashboard')) {
      return void this.router.transitionTo('unauthorized');
    }
    await this.hrisInstall.load();
    if (!this.hrisInstall.isInstalled) {
      return void this.router.transitionTo('unauthorized');
    }
    const canVisit = this.abilities.can('visit hris-dashboard') || this.abilities.can('visit global hris-dashboard');
    if (!canVisit) {
      void this.router.transitionTo('unauthorized');
    }
  }

  model(): { isGlobal: boolean; isReadOnly: boolean } {
    return {
      isGlobal: this.abilities.can('visit global hris-dashboard'),
      isReadOnly: this.abilities.cannot('manage all hris-dashboard') && this.abilities.cannot('manage hris-dashboard'),
    };
  }
}
